import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ServicePage from "@/components/ServicePage";
import Home from "@/pages/Home3";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Work from "@/pages/Work";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import LeadMagnet from "@/pages/LeadMagnet";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Sets a canonical URL on every route to the non-www production origin.
// Tells Google that https://track-digital.com/{path} is the preferred version,
// resolving the "duplicate without user-selected canonical" Search Console warning.
const CANONICAL_ORIGIN = "https://track-digital.com";
const Canonical = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Do not index the admin dashboard as a canonical target.
    if (pathname.startsWith("/admin")) return;
    const href = `${CANONICAL_ORIGIN}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
  }, [pathname]);
  return null;
};

const Layout = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isLeadMagnet = pathname.startsWith("/free/");
  return (
    <>
      <ScrollToTop />
      <Canonical />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/work" element={<Work />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Legal doc="privacy" />} />
        <Route path="/terms" element={<Legal doc="terms" />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/free/:slug" element={<LeadMagnet />} />
      </Routes>
      {!isAdmin && !isLeadMagnet && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
